// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"370":"63b4678a","619":"d624ee84","643":"ef116338","908":"bfbe0ca7"}[chunkId] + ".css";
};